export default __webpack_public_path__ + "static/media/Parichit_Bhasin.fcf3751b.jpg";